module.exports = __webpack_public_path__ + "static/media/BillSchick.ca6943ab.jpg";